<template>
  <div class="row cards-wrapper">
    <div
      v-for="link in links"
      :key="link.image"
      class="link-card"
      :style="{ 'background-image': `url('${getImage(link.image)}')` }"
    >
      <div class="card-inner">
        <h4>{{ link.title }}</h4>
        <a :href="link.url" class="underline"> Naar generator > </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PopupOrderEnvironmentLinks',
  computed: {
    ...mapState({
      frontendSettings: (state) => state.data.settings,
    }),

    links() {
      const {
        url_socket_built_in,
        url_socket_mounted_indoor,
        url_socket_mounted_outdoor,
      } = this.frontendSettings;

      let links = [];

      if (url_socket_built_in) {
        links.push({
          url: url_socket_built_in,
          image: 'socket-built-in.png',
          title: this.$t('PopupOrderEnvironmentLinks.socket_build_in'),
        });
      }

      if (url_socket_mounted_indoor) {
        links.push({
          url: url_socket_mounted_indoor,
          image: 'socket-mounted-indoor.png',
          title: this.$t('PopupOrderEnvironmentLinks.socket_mounted_indoor'),
        });
      }

      if (url_socket_mounted_outdoor && links.length < 2) {
        links.push({
          url: url_socket_mounted_outdoor,
          image: 'socket-mounted-outdoor.png',
          title: this.$t('PopupOrderEnvironmentLinks.socket_mounted_outdoor'),
        });
      }

      return links;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep h4 {
  font-family: $font-antenna-cond !important;
  font-weight: bold;
}
</style>
